import type { BackgroundMedia, ImageContainerDimensions, Image, ResponsiveImageProps } from '@wix/thunderbolt-becky-types'
import type { Experiments } from '@wix/thunderbolt-symbols'
import { getResponsiveImageProps } from '@wix/image-kit'
import type { ImageProps } from '@wix/thunderbolt-components-native'
import _ from 'lodash'

export type ExtraImageProps = {
	containerId?: string
	hasBgScrollEffect?: string
	bgEffectName?: string
	filterEffectSvgString?: string
	displayMode?: BackgroundMedia['fittingType']
	alignType?: BackgroundMedia['alignType']
	dimensions?: ImageContainerDimensions
}

export const getImageProps = (
	imageData: Image,
	extraImageProps: ExtraImageProps,
	experiments: Experiments,
	skipResponsiveImages = false
): ImageProps & { responsiveImageProps?: ResponsiveImageProps } => {
	const containerId = extraImageProps.containerId
	const containerWidth = extraImageProps.dimensions?.width || 0
	const containerHeight = extraImageProps.dimensions?.height || 0

	const extraProps = {
		containerId,
		hasBgScrollEffect: extraImageProps.hasBgScrollEffect === 'true' ? 'true' : '',
		bgEffectName: extraImageProps.bgEffectName || '',
		alignType: extraImageProps.alignType,
		displayMode: extraImageProps.displayMode || 'fill',
		filterEffectSvgString: extraImageProps.filterEffectSvgString,
	}
	const linkProps = imageData.link
	const { hasAnimation, focalPoint, crop, quality, upscaleMethod, alt, width, height, uri } = imageData
	const imageDataProps = { hasAnimation, focalPoint, crop, quality, upscaleMethod, alt, width, height, uri }

	const baseImageProps = {
		..._.omitBy(imageDataProps, (prop) => prop === undefined || prop === ''),
	}

	const avifEncode = experiments['specs.thunderbolt.imageEncodingAVIF'] === true
	const encoding = avifEncode ? { encoding: 'AVIF' } : {}

	const hasFixedDimensions = containerWidth !== 0 && containerHeight !== 0
	const useResponsiveImgClassicFixed = experiments['specs.thunderbolt.useResponsiveImgClassicFixed'] === true

	const imageProps = {
		...baseImageProps,
		...extraProps,
		link: { ...linkProps },
		...focalPoint,
		...quality,
		upscaleMethod,
		hasAnimation,
		...crop,
		...encoding,
	} as ImageProps & { responsiveImageProps?: ResponsiveImageProps }

	const shouldUseResponsiveImages = useResponsiveImgClassicFixed && hasFixedDimensions && !skipResponsiveImages

	if (shouldUseResponsiveImages) {
		imageProps.responsiveImageProps = getResponsiveImageProps(imageProps, containerWidth, containerHeight)
	}

	return imageProps
}
